import { Motif } from '../types'

export const MOTIFS: Motif[] = [
  {
    id: 'electric',
    name: 'Electric',
    description: 'High-energy and futuristic with bold cyan accents',
    tokens: {
      primaryColor: 'cyan',
      secondaryColor: null,
      neutralColor: 'slate',
      displayFont: 'space-grotesk',
      bodyFont: 'inter',
      monoFont: 'jetbrains-mono',
      displayWeight: 'bold',
      bodyWeight: 'medium',
      monoWeight: 'medium',
      displaySize: '4xl',
      bodySize: 'base',
      monoSize: 'sm',
      borderRadius: 'lg',
      shadow: 'lg',
    },
  },
  {
    id: 'fun',
    name: 'Fun',
    description: 'Playful and approachable with soft rounded elements',
    tokens: {
      primaryColor: 'pink',
      secondaryColor: null,
      neutralColor: 'stone',
      displayFont: 'poppins',
      bodyFont: 'nunito',
      monoFont: 'space-mono',
      displayWeight: 'bold',
      bodyWeight: 'regular',
      monoWeight: 'regular',
      displaySize: '4xl',
      bodySize: 'base',
      monoSize: 'sm',
      borderRadius: 'xl',
      shadow: 'md',
    },
  },
  {
    id: 'professional',
    name: 'Professional',
    description: 'Clean and trustworthy with classic blue tones',
    tokens: {
      primaryColor: 'blue',
      secondaryColor: null,
      neutralColor: 'gray',
      displayFont: 'space-grotesk',
      bodyFont: 'inter',
      monoFont: 'ibm-plex-mono',
      displayWeight: 'semibold',
      bodyWeight: 'regular',
      monoWeight: 'medium',
      displaySize: '3xl',
      bodySize: 'base',
      monoSize: 'sm',
      borderRadius: 'md',
      shadow: 'sm',
    },
  },
  {
    id: 'modern',
    name: 'Modern',
    description: 'Minimal and sleek with subtle sophistication',
    tokens: {
      primaryColor: 'zinc',
      secondaryColor: null,
      neutralColor: 'neutral',
      displayFont: 'space-grotesk',
      bodyFont: 'dm-sans',
      monoFont: 'jetbrains-mono',
      displayWeight: 'medium',
      bodyWeight: 'regular',
      monoWeight: 'medium',
      displaySize: '3xl',
      bodySize: 'base',
      monoSize: 'sm',
      borderRadius: 'sm',
      shadow: 'sm',
    },
  },
  {
    id: 'aggressive',
    name: 'Aggressive',
    description: 'Bold and direct with sharp edges and strong contrast',
    tokens: {
      primaryColor: 'red',
      secondaryColor: null,
      neutralColor: 'slate',
      displayFont: 'montserrat',
      bodyFont: 'roboto',
      monoFont: 'jetbrains-mono',
      displayWeight: 'extrabold',
      bodyWeight: 'medium',
      monoWeight: 'bold',
      displaySize: '4xl',
      bodySize: 'base',
      monoSize: 'sm',
      borderRadius: 'none',
      shadow: 'none',
    },
  },
  {
    id: 'bold',
    name: 'Bold',
    description: 'Vibrant and confident with eye-catching violet',
    tokens: {
      primaryColor: 'violet',
      secondaryColor: null,
      neutralColor: 'zinc',
      displayFont: 'montserrat',
      bodyFont: 'work-sans',
      monoFont: 'space-mono',
      displayWeight: 'bold',
      bodyWeight: 'medium',
      monoWeight: 'medium',
      displaySize: '4xl',
      bodySize: 'base',
      monoSize: 'sm',
      borderRadius: 'lg',
      shadow: 'lg',
    },
  },
  {
    id: 'minimal',
    name: 'Minimal',
    description: 'Quiet, refined, and extremely reduced visual noise',
    tokens: {
      primaryColor: 'zinc',
      secondaryColor: null,
      neutralColor: 'stone',
      displayFont: 'inter',
      bodyFont: 'inter',
      monoFont: 'ibm-plex-mono',
      displayWeight: 'medium',
      bodyWeight: 'regular',
      monoWeight: 'regular',
      displaySize: '3xl',
      bodySize: 'base',
      monoSize: 'sm',
      borderRadius: 'sm',
      shadow: 'none',
    },
  },
  {
    id: 'editorial',
    name: 'Editorial',
    description: 'Elegant, text-first, and built for long-form storytelling',
    tokens: {
      primaryColor: 'emerald',
      secondaryColor: null,
      neutralColor: 'stone',
      displayFont: 'playfair-display',
      bodyFont: 'merriweather',
      monoFont: 'ibm-plex-mono',
      displayWeight: 'bold',
      bodyWeight: 'regular',
      monoWeight: 'regular',
      displaySize: '5xl',
      bodySize: 'base',
      monoSize: 'sm',
      borderRadius: 'sm',
      shadow: 'sm',
    },
  },
  {
    id: 'neon',
    name: 'Neon',
    description: 'Vivid, high-contrast, and unapologetically loud',
    tokens: {
      primaryColor: 'fuchsia',
      secondaryColor: null,
      neutralColor: 'slate',
      displayFont: 'poppins',
      bodyFont: 'dm-sans',
      monoFont: 'space-mono',
      displayWeight: 'extrabold',
      bodyWeight: 'medium',
      monoWeight: 'medium',
      displaySize: '5xl',
      bodySize: 'base',
      monoSize: 'sm',
      borderRadius: 'xl',
      shadow: 'lg',
    },
  },
  {
    id: 'classic',
    name: 'Classic',
    description: 'Timeless, credible, and comfortable across industries',
    tokens: {
      primaryColor: 'indigo',
      secondaryColor: null,
      neutralColor: 'gray',
      displayFont: 'libre-baskerville',
      bodyFont: 'merriweather',
      monoFont: 'ibm-plex-mono',
      displayWeight: 'semibold',
      bodyWeight: 'regular',
      monoWeight: 'regular',
      displaySize: '4xl',
      bodySize: 'base',
      monoSize: 'sm',
      borderRadius: 'md',
      shadow: 'sm',
    },
  },
  {
    id: 'studio',
    name: 'Studio',
    description: 'Design-forward with sharp typography and warm neutrals',
    tokens: {
      primaryColor: 'amber',
      secondaryColor: null,
      neutralColor: 'stone',
      displayFont: 'raleway',
      bodyFont: 'work-sans',
      monoFont: 'jetbrains-mono',
      displayWeight: 'semibold',
      bodyWeight: 'regular',
      monoWeight: 'medium',
      displaySize: '4xl',
      bodySize: 'base',
      monoSize: 'sm',
      borderRadius: 'md',
      shadow: 'md',
    },
  },
]

export const getMotifById = (id: string): Motif | undefined => {
  return MOTIFS.find((m) => m.id === id)
}
